/**
 * Created by feiyugao on 2018/11/26.
 * 通路权限 1.QQ主号 2.QQ工号 3.webim 4.微信公众号 5.微信小程序 6.客户通 7.imsdk 8.微信客服， 11.视频客服
 */
const channelState = {
  1: false,
  2: false,
  3: false,
  4: false,
  5: false,
  6: false,
  7: false,
  8: false,
  11: false,
};

const _getType = function (o) {
  let t;
  // eslint-disable-next-line
    return ((t = typeof o) == 'object'
    ? (o == null && 'null') || Object.prototype.toString.call(o).slice(8, -1)
    : t
  ).toLowerCase();
};

export default {
  channelIdToName: {
    1: 'QQ企业主号',
    2: 'QQ工号',
    3: '网页接待',
    4: '微信公众号',
    5: '微信小程序',
    6: '客户通',
    7: 'imsdk',
    8: '微信客服',
    10: '微信小程序插件',
    11: '视频客服',
  },

  /**
     * 获取当前用户套餐
     * @function
     * @returns {Promise}
     */
  getChannelIds() {
    const p = new Promise((resolve, reject) => {
      this.$ajax.get('/tp/channelConf/getKfextChannelList').then(
        (data) => {
          if (+data.r === 0) {
            resolve(data.data);
          } else {
            reject();
          }
        },
        (error) => {
          console.log(error);
          reject(error);
        },
      );
    });
    return p;
  },
  // 通用id 3 表示webim,有很多地方 4 表示网页会话，如需转换这里统一做map
  channelIdsMap(ids) {
    const map = {
      1: 1, // QQ-企业主号
      2: 5, // QQ-员工号
      3: 4, // 网页会话
      4: 3, // 微信公众号
      5: 7, // 微信小程序
      6: 51, // 微信-企业微信
      7: 50, // APP
      8: 53, // 微信客服
      11: 56, // 视频客服
    };
    return ids.map(id => map[id] || id);
  },
  /**
     * 检查一组套餐是否都在另一组(用户拥有的)套餐中
     * @function
     * @param val 需要检查的套餐
     * @param data 当前的套餐(通常是当前用户所拥有的套餐)
     * @returns {Boolean} 是否拥有
     * @example
     * // checkChannelInData([1, 2, 3], [1, 2, 3, 4, 5]);
     * // true
     * // checkChannelInData([1, 2, 3], [1, 2, 4, 5]);
     * // false
     */
  checkChannelInData(val, data) {
    let result = true;
    for (let i = 0; i < data.length; i++) {
      channelState[data[i]] = true;
    }
    for (let i = 0; i < val.length; i++) {
      if (!channelState[val[i]]) {
        result = false;
      }
    }
    return result;
  },

  /**
     * 检查一组套餐是否都在另一组(用户拥有的)套餐中，如果第一个元素是数组则对每个元素进行checkChannelInData检查，有任何一个元素结果为true结果就是true
     * @function
     * @param val 需要检查的套餐(组)
     * @param data 当前的套餐(通常是当前用户所拥有的套餐)
     * @returns {Boolean} 是否拥有
     * @example
     * // checkChannelInDataPlus([1, 2, 3], [1, 2, 3, 4, 5]);
     * // true
     * // checkChannelInDataPlus([1, 2, 3], [1, 2, 4, 5]);
     * // false
     * // checkChannelInDataPlus([[1, 2], [1, 3]], [1, 2, 4, 5]);
     * // false
     */
  checkChannelInDataPlus(val, data) {
    let result = true;
    if (_getType(val[0]) === 'array') {
      result = false;
      try {
        for (let i = 0; i < val.length; i++) {
          if (_getType(val[i]) !== 'array') {
            throw new Error('如果首个元素为数组，所有元素都需要设置为数组');
          }
          if (this.checkChannelInData(val[i], data)) {
            result = true;
          }
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      result = this.checkChannelInData(val, data);
    }
    return result;
  },

  /**
     * 检查一组套餐是否都不在另一组(用户拥有的)套餐中
     * @function
     * @param val 需要检查的套餐
     * @param data 当前的套餐(通常是当前用户所拥有的套餐)
     * @returns {Boolean} 是否都不拥有
     * @example
     * // checkChannelNotInData([1,2,3], [4, 5]);
     * // true
     * // checkChannelNotInData([1,2,3], [3, 5]);
     * // false
     */
  checkChannelNotInData(val, data) {
    let result = true;
    for (let i = 0; i < data.length; i++) {
      channelState[data[i]] = true;
    }
    for (let i = 0; i < val.length; i++) {
      if (channelState[val[i]]) {
        result = false;
      }
    }
    return result;
  },
  /**
     *  根据 通路权限 检查是否 disable kind
     * 如果未包含 QQ主号、QQ工号、webim 任一通路，isDisabled:true
     * @function
     * @param val 需要检查的 通路权限
     * @returns {Boolean} 是否disable kind
     * @example
     * checkKindDisable([1,2,3]);
     * true
     * checkKindDisable([4,5]);
     * false
     */
  checkKindDisable(val) {
    let result = true;
    const enableChanel = [1, 2, 3, 11];
    result = val.some(r => enableChanel.includes(r));
    return result;
  },
};
